import styled from 'styled-components/native';

export const Wrapper = styled.View`
  width: ${(props) => props.theme.tokens.sizes.full};
  max-width: 347px;
`;
